import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import FeaturesListPlayground from 'src/app/organisms/Homepage/FeaturesListPlayground/FeaturesListPlayground';

const FeaturesList = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
  >
    <FeaturesListPlayground />
  </SectionLayout>
);

export default FeaturesList;
